import { c as _c } from "react/compiler-runtime";
import { useQueryStates } from 'nuqs';
import { parseAsSearchString, SELECT_ALL_VALUE } from '@/hooks/searchParamParsers';
import { useEffect, useMemo, useState } from 'react';
import { FormApi, createForm } from 'final-form';
export type SearchFormValues = {
  fulltext?: string;
  category?: string;
  coupon?: string;
};
export const FIELD_CATEGORY = 'category';
export const FIELD_FULLTEXT = 'fulltext';
export const FIELD_COUPON = 'coupon';
export function useFormSearch(t0) {
  const $ = _c(20);
  let t1;
  if ($[0] !== t0) {
    t1 = t0 === undefined ? {} : t0;
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const defaultFormValues = t1;
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      q: parseAsSearchString,
      cat: parseAsSearchString,
      coupon: parseAsSearchString
    };
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const [searchParams, setSearchParams] = useQueryStates(t2);
  const t3 = searchParams.q ?? "";
  const t4 = searchParams.cat && searchParams.cat !== SELECT_ALL_VALUE ? searchParams.cat : defaultFormValues.category;
  const t5 = searchParams.coupon ?? undefined;
  let t6;
  if ($[3] !== t3 || $[4] !== t4 || $[5] !== t5) {
    t6 = {
      fulltext: t3,
      category: t4,
      coupon: t5
    };
    $[3] = t3;
    $[4] = t4;
    $[5] = t5;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  const formValues = t6;
  let t7;
  if ($[7] !== setSearchParams) {
    t7 = values => {
      setSearchParams({
        q: values.fulltext || null,
        cat: values.category && values.category !== SELECT_ALL_VALUE ? values.category : null,
        coupon: values.coupon || null
      });
    };
    $[7] = setSearchParams;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  const sync = t7;
  let t8;
  if ($[9] !== formValues || $[10] !== sync) {
    t8 = () => createForm({
      initialValues: formValues,
      onSubmit: values_0 => {
        sync(values_0);
      }
    });
    $[9] = formValues;
    $[10] = sync;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  const [searchForm] = useState(t8);
  let t10;
  let t9;
  if ($[12] !== formValues || $[13] !== searchForm) {
    t9 = () => {
      if (typeof window !== "undefined") {
        searchForm.reset(formValues);
      }
    };
    t10 = [formValues, searchForm];
    $[12] = formValues;
    $[13] = searchForm;
    $[14] = t10;
    $[15] = t9;
  } else {
    t10 = $[14];
    t9 = $[15];
  }
  useEffect(t9, t10);
  let t11;
  if ($[16] !== formValues || $[17] !== searchForm || $[18] !== sync) {
    t11 = {
      formValues,
      sync,
      searchForm
    };
    $[16] = formValues;
    $[17] = searchForm;
    $[18] = sync;
    $[19] = t11;
  } else {
    t11 = $[19];
  }
  return t11;
}